import { Property } from 'csstype';
import { color } from './color';

const fontFamily = 'Roboto, Arial, Helvetica, sans-serif';

const fontStyles = (size: string, weight: Property.FontWeight = 'normal'): theme.FontStyle => ({
    fontFamily: fontFamily,
    fontStyle: 'normal',
    fontWeight: weight,
    fontSize: `${size}`,
    lineHeight: '130%',
    letterSpacing: '0.02em',
    color: color.Grey.G80,
});

export const fontTypeToObject = (type: theme.FontType) => {
    const item = type.split('.');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (font as any)[item[0]][item[1]] as theme.FontStyle;
};

export const font: theme.IFont = {
    xSmall: {
        regular: { ...fontStyles('9px') },
        bold: { ...fontStyles('9px', 'bold') },
    },

    small: {
        regular: { ...fontStyles('12px') },
        medium: { ...fontStyles('12px', 500) },
        bold: { ...fontStyles('12px', 'bold') },
        allCaps: { ...fontStyles('12px', 'bold'), textTransform: 'uppercase' },
    },

    normal: {
        regular: { ...fontStyles('14px') },
        medium: { ...fontStyles('14px', 500) },
        bold: { ...fontStyles('14px', 'bold') },
        allCaps: { ...fontStyles('14px', 'bold'), textTransform: 'uppercase' },
    },

    intermediate: {
        medium: { ...fontStyles('15px', 500) },
    },

    large: {
        regular: { ...fontStyles('16px') },
        medium: { ...fontStyles('16px', 500) },
        bold: { ...fontStyles('16px', 'bold') },
        allCaps: { ...fontStyles('16px', 'bold'), textTransform: 'uppercase' },
    },

    xLarge: {
        regular: { ...fontStyles('20px') },
        medium: { ...fontStyles('20px', 500) },
        bold: { ...fontStyles('20px', 'bold') },
    },

    xxxLarge: {
        bold: { ...fontStyles('48px', 'bold') },
    },
};
